import { createSlice } from "@reduxjs/toolkit";

export const UserDetailsSlice = createSlice({
    name: "userDetail",
    initialState: {
      userDetails: {},
    },
  reducers: {
    saveUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
  },
});

export const { saveUserDetails } = UserDetailsSlice.actions;

export default UserDetailsSlice.reducer;